/**
 * Created by evgenijsenkevic on 23/7/25
 */

cleverapps.styles.OfferButtonComponent[Offers.TYPES.STICKERS_PACK] = cleverapps.overrideStyles(cleverapps.styles.OfferButtonComponent, {
    badge: {
        rotation: 30,
        largeFont: true
    },
    position: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: -20 }
    }
}, true);
